import { all, call, put, takeLeading, select } from 'redux-saga/effects';
import { actions, types } from '@src/store';
import { selectSubscriberId } from '@src/store/selectors';
import { fetchPlans, fetchUserPlan } from '@src/apis/Plans';

const logger = Logger.get('plans/saga');

function* plansSaga(){
    yield all([
        takeLeading( types.plans.GetPlans, getPlansList )
    ]);
}


export function* getPlansList( { subscriberId } = {} ){
    try{
        
        if( !subscriberId ) subscriberId = yield select( selectSubscriberId );

        const plans = yield call( fetchPlans );

        yield put( actions.plans.SetPlans( { plans } ) );

        if( subscriberId ){
             
            const userPlan =  yield call( fetchUserPlan , { subscriberId } );

            yield put( actions.plans.SetUserplan( { userPlan } ) );

        }
       
    }
    catch( error ){
        logger.log( error );
    }
}


export default plansSaga